<template>
  <div id="d3d-container" :class="{'video-box': video, 'container-box': container}">
    <router-link to="/" replace v-if="! xinhua">
      <img src="@/assets/images/go-home.png" class="home">
    </router-link>
    <img :src="currentExhibition" class="image" v-if="currentExhibition && container">
    <template v-else>
      <img :src="currentBakcground" class="background" v-if="currentBakcground">
      <img src="@/assets/images/loading.gif" alt="" class="loading" v-if="loading">
      <img :src="currentExhibition" alt="" class="gif" v-if="gif">
      <div class="audio" v-if="audio">
        <div class="box">
          <img :src="cover" class="cover">
          <img src="@/assets/images/pause.png" class="control" @click="audioPlaying = false" v-if="audioPlaying">
          <img src="@/assets/images/play.png" class="control" @click="audioPlaying = true" v-else>
        </div>
        <div class="slider">
          <span>{{ getTime( audioStart ) }}</span>
          <van-slider class="value" v-model="audioRate" bar-height="4px" active-color="white"
                      inactive-color="rgba(255, 255, 255, 0.3)" button-size="17px" @drag-start="audioPlaying = false"
                      @drag-end="audioPlaying = true"/>
          <span>{{ getTime( audioTotal ) }}</span>
        </div>
        <audio :src="currentExhibition" @timeupdate="audioUpdate" @canplay="initAudio" @pause="onAudioPause" ref="audio"></audio>
      </div>
      <video webkit-playsinline playsinline x5-video-player-type="h5-page" :src="currentExhibition" class="video"
             ref="video" v-if="video" controls :poster="currentOtherImages ? currentOtherImages[0] : ''"></video>
      <div class="music" v-if="music" @click="musicPlaying = ! musicPlaying">
        <template v-if="musicPlaying">
          <span>{{ musicCountdown }}S</span>
          <img src="@/assets/images/pause-small.png">
        </template>
        <template v-else>
          <span>试听</span>
          <img src="@/assets/images/play-small.png">
        </template>
        <audio :src="music" ref="music" @canplay="initMusic" @timeupdate="musicUpdate" @pause="onAudioPause"></audio>
      </div>
    </template>
  </div>
</template>

<script>
import client from '@/configs/client.js'
import functions from '@/functions'

export default {
  name: 'ShowCaseComponent',
  props: {
    cover: {
      type: String
    },
    intensity: {
      type: Number,
      default () {
        return 2
      }
    },
    background: {
      type: String
    },
    exhibition: {
      type: String
    },
    otherImages: {
      type: Array
    },
    container: {
      type: Boolean,
      default () {
        return false
      }
    },
    music: {
      type: String,
      default () {
        return ''
      }
    },
    productKey: {
      type: Number,
      default () {
        return 0
      }
    }
  },
  data () {
    return {
      gif: false,
      audio: false,
      video: false,
      loading: true,
      audioRate: 0,
      audioStart: 0,
      audioTotal: 0,
      audioPlaying: false,
      musicTotal: 0,
      musicCountdown: 0,
      musicPlaying: false,
      xinhua: client.xinhua,
      currentOtherImages: this.otherImages,
      currentBakcground: this.background,
      currentExhibition: this.exhibition
    }
  },
  created () {
    let loading = true
    let timer = setInterval( () => {
      if ( !loading ) {
        this.loading = loading
        clearInterval( timer )
      }
      if ( document.querySelector( '#d3d-container canvas' ) || document.querySelector( '#d3d-container .gif' ) || document.querySelector( '#d3d-container .audio' ) || document.querySelector( '#d3d-container .video' ) ) {
        // 加载音频
        if ( $( '.audio' ).length ) {
          let audio = $( '.audio audio' )[ 0 ]
          if ( !audio.src ) {
            audio.src = this.currentExhibition
            audio.load()
            audio.oncanplay = () => {
              this.audioTotal = Math.ceil( audio.duration )
            }
          }
        }
        loading = false
      }
    }, 500 )

  },
  mounted () {
    this.init()
  },
  unmounted () {
    window.show3dModel = false
    window.d3modelInitBefore = false
  },
  methods: {
    toggleMusicState () {
      // 这里要关闭可能存在的媒体播放器，8.8.54支持
      try {
        if (client.xinhua) {
          if (functions.usableXinhuaVersion('8.8.54')) {
            window.xinhuanetApp.closeAudioSuspensionFun()
          }
        }
      } catch ( err ) {
        console.log(err)
      }
      if ( this.musicPlaying ) {
        if ( !this.musicCountdown ) {
          this.$refs.music.currentTime = 0
        }
        this.$refs.music.play()
      } else {
        this.$refs.music.pause()
      }
    },
    musicUpdate ( event ) {
      this.musicCountdown = this.musicTotal - Math.ceil( event.target.currentTime )
    },
    initMusic ( event ) {
      this.musicTotal = Math.ceil( event.target.duration )
      this.musicCountdown = this.musicTotal
    },
    toggleAudioState () {
      if ( this.audioPlaying ) {
        if ( this.audioStart == this.audioTotal ) {
          this.$refs.audio.currentTime = 0
        } else {
          this.$refs.audio.currentTime = this.audioRate / 100 * this.audioTotal
        }
        this.$refs.audio.play()
      } else {
        this.$refs.audio.pause()
      }
    },
    audioUpdate ( event ) {
      this.audioStart = Math.ceil( event.target.currentTime )
    },
    initAudio ( event ) {
      this.audioTotal = Math.ceil( event.target.duration )
    },
    // 音频暂停事件
    onAudioPause () {
      this.audioPlaying = false
      this.musicPlaying = false
    },
    getTime ( value ) {
      let minute = Math.floor( value / 60 )
      let second = value % 60
      return ( minute > 9 ? minute : '0' + minute ) + ':' + ( second > 9 ? second : '0' + second )
    },
    init () {
      if ( this.currentExhibition && !this.container ) {
        let extension = this.currentExhibition.replace( /.*\./, '' )
        if ( extension == 'gif' ) {
          this.gif = true
        } else if ( extension == 'mp3' ) {
          this.audio = true
        } else if ( extension == 'mp4' ) {
          this.video = true
        } else {
          window.show3dModel = true
          window.modelIntensity = this.intensity
          if ( location.pathname.indexOf( 'xhdc' ) === 1 ) {
            if ( this.productKey == 376 || this.productKey == 377 || this.productKey == 378 ) {
              window.modelIntensity = 10
            }
          }
          window.modelIntensity = window.modelIntensity == null ? 2 : window.modelIntensity
          if ( location.pathname.indexOf( 'xhdc' ) === 1 ) {
            if ( this.productKey == 301 || this.productKey == 302 || this.productKey == 303 ) {
              let d3modelInitBeforeCommon = function ( scene ) {
                scene.state.addLights = !1
                scene.state.withEnvMap = !1
                scene.state.orbitLockY = !0
                scene.state.orbitLimitRotation = !0
                scene.state.dampingFactor = .02
                scene.state.rotateSpeed = .5
                scene.state.camConfig = {
                  near: .1,
                  far: 1E3
                }
                scene.state.autoRotate = !1
              }
              if ( this.productKey == 301 ) {
                window.d3modelInitBefore = function ( scene ) {
                  d3modelInitBeforeCommon( scene )
                  scene.state.initCam = {
                    orbitTarget: new THREE.Vector3( .18, 4.88, 5.65 ),
                    orbitPos: new THREE.Vector3( -2.25, 7.09, 16.5 )
                  }
                  scene.state.orbitZoomLimit = {
                    minDist: 6,
                    maxDist: 12
                  }
                }
              } else if ( this.productKey == 302 ) {
                window.d3modelInitBefore = function ( scene ) {
                  d3modelInitBeforeCommon( scene )
                  scene.state.initCam = {
                    orbitTarget: new THREE.Vector3( -16.5, 52.4, 19.95 ),
                    orbitPos: new THREE.Vector3( -29.8, 79.1, 275.4 )
                  }
                  scene.state.orbitZoomLimit = {
                    minDist: 160,
                    maxDist: 300
                  }
                }
              } else if ( this.productKey == 303 ) {
                window.d3modelInitBefore = function ( scene ) {
                  d3modelInitBeforeCommon( scene )
                  scene.state.initCam = {
                    orbitTarget: new THREE.Vector3( -2, 4.2, 4.9 ),
                    orbitPos: new THREE.Vector3( -1.59, 4.2, 25 )
                  }
                  scene.state.orbitZoomLimit = {
                    minDist: 10,
                    maxDist: 26
                  }
                  scene.state.culled = !1
                }
              }
            }
          }
          window.d3model.init3dModel( this.currentExhibition, [ 'glb', 'fbx', 'obj' ].indexOf( extension ) == -1 )
        }
      }
    }
  },
  watch: {
    musicCountdown ( value ) {
      if ( !value ) {
        this.musicPlaying = false
      }
    },
    musicPlaying () {
      this.toggleMusicState()
    },
    audioPlaying () {
      this.toggleAudioState()
    },
    audioStart () {
      this.audioRate = this.audioStart / this.audioTotal * 100
      if ( this.audioRate >= 100 ) {
        this.audioPlaying = false
      }
    },
    otherImages ( value ) {
      this.currentOtherImages = value
    },
    background ( value ) {
      this.currentBakcground = value
    },
    exhibition ( value ) {
      this.currentExhibition = value
    },
    currentExhibition () {
      this.init()
    }
  }
}
</script>

<style lang="scss" scoped>
#d3d-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 375px;
  overflow: hidden;

  &.video-box {
    height: 312px;
    padding: 45px 8px 55px 8px;
  }

  &.container-box {
    height: 210px;

    .image {
      width: 100%;
      height: 100%;
    }
  }

  .home {
    position: absolute;
    z-index: 4;
    top: 10px;
    left: 10px;
    width: 20px;
    height: 20px;
  }

  .background {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    filter: blur(10px);
    transform: scale(1.1);
  }

  .loading {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
  }

  .gif {
    position: relative;
    z-index: 3;
    display: block;
    width: 100%;
    height: 100%;
  }

  .audio {
    z-index: 3;
    width: 100%;
    max-height: 100%;

    .box {
      position: relative;
      width: 219px;
      height: 219px;
      margin: 0 auto;
      overflow: hidden;
      border-radius: 50%;

      .cover {
        width: 100%;
        height: 100%;
      }

      .control {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 64px;
        height: 64px;
        transform: translate(-50%, -50%);
      }
    }

    .slider {
      display: flex;
      align-items: center;
      color: white;
      font-size: 12px;
      margin: 20px 20px 0;

      .value {
        margin: 0 16px;
      }
    }
  }

  .video {
    position: relative;
    z-index: 3;
    width: 100%;
    max-height: 100%;
    border-radius: 8px;
  }

  .music {
    position: absolute;
    z-index: 4;
    bottom: 36px;
    display: flex;
    align-items: center;
    color: white;
    font-size: 12px;
    padding: 5px 19px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 17px;

    img {
      width: 8px;
      height: 8px;
      margin-left: 8px;
    }
  }

  :deep(canvas) {
    position: relative;
    z-index: 3;
    width: 100% !important;
    height: 100% !important;
  }
}
</style>
